<template>
  <div class="row">
    <div class="col-12 col-md-2 col-xl-1">
      <input-select-search
        ref="anoLetivoId"
        :label="$t(`ACADEMICO.ANO_LETIVO`)"
        :options="opcoes.anosLetivos"
        v-model="filtro.anoLetivoId"
        @input="$emit('change')"
        required
      />
    </div>
    <div class="col-12 col-md-2 col-xl-2">
      <input-select-search
        ref="segmentacaoId"
        :label="$t(`ACADEMICO.SEGMENTACAO`)"
        :options="opcoes.segmentacoes"
        v-model="filtro.segmentacaoId"
        :isDisabled="desabilitar.segmentacao"
        @input="$emit('change')"
        required
      />
    </div>
    <div class="col-12 col-md-4 col-lg-3 col-xl-2">
      <input-select-search
        ref="cursoId"
        :label="$t(`ACADEMICO.CURSO`)"
        :options="opcoes.cursos"
        v-model="filtro.cursoId"
        :isDisabled="desabilitar.curso"
        @input="$emit('change')"
        required
      />
    </div>
    <div class="col-12 col-md-4 col-lg-3 col-xl-2">
      <input-select-search
        ref="turmaId"
        :label="$t(`ACADEMICO.TURMA`)"
        :options="opcoes.turmas"
        v-model="filtro.turmaId"
        :isDisabled="desabilitar.turma"
        @input="$emit('change')"
        required
      />
    </div>
     <div class="col-12 col-md-auto align-items-center">
        <b-button
          variant="primary"
          class="botao-acao-filtro w-100"
          @click="filtrar"
        >
          {{ $t('GERAL.FILTRAR') }}
        </b-button>
      </div>
      <div class="col-12 col-md-auto">
        <b-button
          variant="secondary"
          class="botao-acao-filtro mt-3 w-100"
          @click="limparFiltro"
        >
          {{ $t('GERAL.LIMPAR') }}
        </b-button>
      </div>
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import CursoService from '@/common/services/academico/curso.service';
import TurmaService from '@/common/services/academico/turma.service';
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';

import { InputSelectSearch } from '@/components/inputs';

export default {
  components: {
    InputSelectSearch,
  },
  data() {
    return {
      filtro: {
        anoLetivoId: '',
        segmentacaoId: '',
        cursoId: '',
        turmaId: '',
      },
      desabilitar: {
        turma: true,
        segmentacao: true,
        curso: true,
      },
      opcoes: {
        anosLetivos: [],
        cursos: [],
        segmentacoes: [],
        turmas: [],
      },
    };
  },
  mounted() {
    this.getAnosLetivo();
    this.$emit('refs', this.$refs);
  },
  watch: {
    filtro: {
      handler(filtro) {
        const { cursoId, anoLetivoId, segmentacaoId, turmaId } = filtro;
        if (cursoId && anoLetivoId && segmentacaoId && turmaId) {
          this.$emit('filtrar', JSON.parse(JSON.stringify(this.filtro)));
        }
      },
      deep: true,
    },
    'filtro.anoLetivoId'(anoLetivoId) {
      if (anoLetivoId) {
        this.getCursos(anoLetivoId);
        this.getSegmentacoes();
      } else {
        this.opcoes.cursos = [];
        this.opcoes.turmas = [];
        this.opcoes.segmentacoes = [];
        this.desabilitar.curso = true;
        this.desabilitar.turma = true;
        this.desabilitar.segmentacao = true;
      }
      this.filtro.cursoId = null;
      this.filtro.turmaId = null;
      this.filtro.segmentacaoId = null;
    },
    'filtro.cursoId'(cursoId) {
      if (cursoId) {
        this.getTurmas();
      } else {
        this.desabilitar.turma = true;
        this.opcoes.turmas = [];
      }
      this.filtro.turmaId = null;
    },
  },
  methods: {
    getAnosLetivo() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar(this.paginacao)
        .then(({ data }) => {
          data.forEach((element) => {
            element.text = element.ano;
            element.value = element.id;
          });
          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getSegmentacoes() {
      this.opcoes.anosLetivos.forEach((element) => {
        if (element.id == this.filtro.anoLetivoId) {
          this.opcoes.segmentacoes = element.segmentacoes;
          this.opcoes.segmentacoes.forEach((segmentacao) => {
            segmentacao.text = segmentacao.descricao;
            segmentacao.value = segmentacao.id;
          });
          this.desabilitar.segmentacao = false;
        }
      });
    },
    getCursos(anoLetivoId) {
      this.$store.dispatch(START_LOADING);
      CursoService.obterPorAnoLetivo(anoLetivoId)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.cursos = data;
          this.desabilitar.curso = false;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getTurmas() {
      this.$store.dispatch(START_LOADING);
      TurmaService.buscarPorCursoAnoLetivo(this.filtro)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.turmas = data;
          this.habilitarCampo('turma');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    habilitarCampo(key) {
      this.desabilitar[key] = false;
    },
    // FUNÇÕES FILTRO:
    validarFiltro() {
      return helpers.validarFormulario(this.$refs);
    },
    filtrar() {
      if (!this.validarFiltro()) return;
      this.$emit('filtrar', this.filtro);
    },
    limparFiltro() {
      this.filtro = {
        anoLetivoId: '',
        segmentacaoId: '',
        cursoId: '',
        turmaId: '',
      };
      this.desabilitar = {
        turma: true,
        segmentacao: true,
        curso: true,
      };
      this.$emit('limpar-filtro');
    },
  },
};
</script>
